import { HELP } from './index'
import { registerRoute } from '@/router'
import { useContaCommand } from '@/commandbar/commandBar.service'
import { useBreadCrumbs } from '@/breadcrumbs/useBreadCrumbs'
import { NavGroup, registerNavigationEntry } from '@/navigation'

const { registerNavigationCommand } = useContaCommand()
const { buildSimpleCrumb } = useBreadCrumbs()

registerRoute(HELP)
const label = 'Hjelp'
const icon = 'i-ph-question-fill'

registerNavigationCommand({
    route: HELP,
    label,
    icon,
    hotkey: 'h'
})

registerNavigationEntry(NavGroup.START, {
    title: label,
    key: 'help',
    icon,
    target: HELP
})

buildSimpleCrumb(HELP, label, icon)
